angular.module('picmonicng').directive('plsDropdown', [
  function () {
    return {
      restrict: 'E',
      transclude: true,
      require: 'ngModel',
      scope: {
        label: '@',
        labelPrefix: '@',
        open: '@',
        ngModel: '=',
        items: '=',
        onSelect: '&',
      },
      templateUrl: '/templates/directives/pls-dropdown.html',
      controller: [
        '$scope',
        function ($scope) {
          $scope.open = $scope.open === true;

          $scope.toggleOpen = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            $scope.addClickToClose();
            $scope.open = !$scope.open;
          };

          $scope.closeMenu = function () {
            $scope.removeClickToClose();
            $scope.open = false;
          };
        },
      ],
      link: function (scope, element, attrs, ngModel) {
        scope.select = function (item) {
          scope.open = false;
          ngModel.$setViewValue(item);

          if (typeof scope.onSelect == 'function') {
            scope.onSelect({ $item: item });
          }
        };

        function clickHandler(e) {
          if (
            scope.open == true &&
            element[0] != e.target &&
            !angular.element(element).has(angular.element(e.target)).length
          ) {
            scope.closeMenu();
            scope.$apply();
          }
        }

        scope.addClickToClose = function () {
          document.body.addEventListener('click', clickHandler, true);
        };

        scope.removeClickToClose = function () {
          document.body.removeEventListener('click', clickHandler, true);
        };
      },
    };
  },
]);
